import Error403 from "pages/Error/Error403";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";

interface AccessControlProps {
    privilege: string;
    children: React.ReactNode;
    ifCondition?: boolean
}

const AccessControl: React.FC<AccessControlProps> = ({ privilege, children, ifCondition=true }) => {

    const privileges = useSelector((state: RootState) => state.auth.privileges);

    if (!privileges.includes(privilege) || !ifCondition) {
        return null;
    }

    return (
        <React.Fragment>{children}</React.Fragment>
    )
}

export default AccessControl